@if (show) {
  <div class="popup-bg">
    <div class="container anim-popup tw-font-body" (click)="stopEvent($event)">
      @if (title) {
        <div class="mB15 bold fontL3">
          <translate-string [key]="title"></translate-string>
        </div>
      }
      @if (titleIcon) {
        <div class="mB15 text-center">
          <em [class]="titleIcon"></em>
        </div>
      }
      @if (message.text) {
        <div class="message" [innerHTML]="message.text"></div>
      }
      @if (message.type) {
        <div class="message">
          @switch (message.type) {
            @case (appConfig.Shared.String.UPDATE_APP_DETAIL) {
              <div i18n="@@yourCurrentAppVersionNotSupported">
    Your current app version is not supported. Kindly upgrade to continue
    using our service.
    </div>
            }
            @case (appConfig.Shared.String.UPDATE_BROWSER_DETAIL) {
              <div i18n="@@youNeedTheLatestVersion">
    You need the latest version of following apps to continue
    </div>
            }
            @case (appConfig.Shared.String.INSTANT_CHECKUP_RATING) {
              <div i18n="@@instantCheckupFeedback">
    Instant Skin Analysis are free to help users evaluate their skin. Let us
    know how your experience was.
    </div>
            }
            @case (appConfig.Shared.String.OFFLINE) {
              <div i18n="@@youAreOffline">
    You are offline. Kindly check the internet connectivity.
    </div>
            }
            @case (appConfig.Shared.String.CANCEL_ORDER_OFFER_CONFIRM) {
              <div>
                @if (user?.get('orderState') !== appConfig.Shared.User.OrderState.DELIVERED) {
                  <div i18n="@@cancelOrderConfirmationTreatment">
      Call us between 10 am to 7 pm for any questions about your treatment
      kit
    </div>
                }
                @if (user?.get('orderState') !== appConfig.Shared.User.OrderState.DELIVERED) {
                  <div class="pT15 bold">
                    <em class="cs-icon-phone-in-talk fontL3 pR10"></em><a class="clr-link fontL1" href="tel:081-500-96500">081-500-96500</a>
                  </div>
                }
              </div>
            }
            @case (appConfig.Shared.String.ORDER_CANCEL_REASON) {
              <div i18n="@@orderCancelReason">
    Order is cancelled. Please let us know the reason.
    </div>
            }
            @case (appConfig.Shared.String.LOGOUT_CONFIRM) {
              <div i18n="@@logoutConfirmation">
    Are you sure you want to log out?
    </div>
            }
            @case (appConfig.Shared.String.RATE_US) {
              <div i18n="@@thanksRateUs">
    Thanks for the feedback. Please rate us 5 star.
    </div>
            }
            @case (appConfig.Shared.String.PINCODE) {
              <div i18n="@@invalidPincode">
    Pincode looks wrong, Do you want to autofill the correct pincode?
    </div>
            }
            @case (appConfig.Shared.String.ORDER_SELECTION) {
              <div class="fontL2 bold" i18n="@@chooseOrder">
    Choose Order
    </div>
            }
            @case (appConfig.Shared.String.PRODUCT_SELECTION) {
              <div class="fontL2 bold">
                Choose Product
              </div>
            }
          }
        </div>
      }
      @if (appConfig.Dialog.MULTI_OPTION_SINGLE_SELECT === type) {
        <div [ngClass]="{ 'tw-h-[85%] tw-overflow-auto': appConfig.Shared.String.ORDER_SELECTION }">
          @for (option of options; track option; let i = $index) {
            <div class="mB15">
              <radio-btn [checked]="option.selected" (checkedChange)="optionSingleSelectionChange(i)">
                <div>
                  <div class="fontR bold">{{option.text}}</div>
                  <div class="fontS1">{{option.subText}}</div>
                </div>
              </radio-btn>
            </div>
          }
        </div>
      }
      @if (appConfig.Dialog.MULTI_OPTION_SINGLE_SELECT === type) {
        <div class="confirmation" [ngClass]="{ 'tw-pt-2 tw-sticky tw-bottom-0': appConfig.Shared.String.ORDER_SELECTION }">
          <div class="w50">
            <cs-button (callback)="onClickNo()" [class]="'secondary only-text pL0 btn-xs'"><cs-button-text><translate-string [key]="cancelText"></translate-string></cs-button-text></cs-button>
          </div>
          <div class="w50">
            <cs-button (callback)="onOptionConfirm()" [class]="'primary w100 btn-xs'"><cs-button-text><translate-string [key]="okText"></translate-string></cs-button-text></cs-button>
          </div>
        </div>
      }
      @if (appConfig.Dialog.ALERT === type) {
        <div class="flex justify-end">
          <cs-button (callback)="onClickNo()" [class]="'pLR15 primary bold ls-05 only-text'"><cs-button-text><translate-string [key]="cancelText"></translate-string></cs-button-text></cs-button>
        </div>
      }
      @if (appConfig.Dialog.CONFIRMATION === type) {
        <div class="confirmation" [ngClass]="{ 'tw-pt-2 tw-sticky tw-bottom-0': appConfig.Shared.String.ORDER_SELECTION }">
          <div class="w50">
            <cs-button (callback)="onClickYes()" [class]="'secondary only-text pL0 btn-xs'"><cs-button-text><translate-string [key]="okText"></translate-string></cs-button-text></cs-button>
          </div>
          <div class="w50">
            <cs-button (callback)="onClickNo()" [class]="'primary w100 btn-xs'"><cs-button-text><translate-string [key]="cancelText"></translate-string></cs-button-text></cs-button>
          </div>
        </div>
      }
      @if (appConfig.Dialog.MULTI_BUTTON === type) {
        <div class="flex justify-evenly">
          @for (input of inputs; track input; let i = $index) {
            <div class="w100" [ngClass]='{ "mB15": i !== inputs.length - 1}'>
              <cs-button class="w100" [class]="'w100 primary'" (callback)="selectedMultiInput(input.text)"><cs-button-text><translate-string [key]="input.text"></translate-string></cs-button-text></cs-button>
            </div>
          }
        </div>
      }
      @if (appConfig.Dialog.RADIO_BUTTON === type) {
        <div>
          @for (input of inputs; track input) {
            <div class="w100">
              <cs-button [class]="'w100 primary only-text'" (callback)="selectedRadioInput(input.text)"><cs-button-text><translate-string [key]="input.text"></translate-string></cs-button-text></cs-button>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
